webpackJsonp([81100621921468],{

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LeifNixon = __webpack_require__(51);
	
	var _LeifNixon2 = _interopRequireDefault(_LeifNixon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeifNixon = function LeifNixon() {
	    return _react2.default.createElement(
	        'section',
	        { id: 'speaker', className: 'parallax-section' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-sm-12 wow fadeInUp', 'data-wow-delay': '0.1s' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'team-wrapper' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Leif Nixon'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement('img', { src: _LeifNixon2.default, className: 'img-responsive', alt: 'Leif Nixon' }),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'social-icon' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement('a', { href: 'https://twitter.com/leifnixon', target: '_blank', className: 'fa fa-twitter wow fadeIn' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-5' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Leif Nixon, founder and owner of Nixon Security, has more than 10 years experience from IT security in Linux-centric environments. He regularly coordinates response to complex, multi-national incidents, and has a wide network of contacts in industry, academia and law enforcement.',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    'A regular contributor to industrial and academic IT security conferences, he is well prepared to give presentations on a range of subjects.'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Talk: HORRORLARITY'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Whether to laugh or to cry, or both at the same time? Working in IT security can lead to some very mixed emotions. ',
	                                _react2.default.createElement('br', null),
	                                'We will revisit some of the speaker\'s favourite security vulnerabilities, to laugh, and maybe cry, together. We will cover things like the app-enabled toilet with crap security, the shockingly bad smart grid system, and the open source repository that was really, REALLY open.'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = LeifNixon;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-speakers-leif-nixon-js-c5c1419ae0f0d7d402cd.js